/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { PlusIcon16Light } from './PlusIcon16Light';
import { PlusIcon16Regular } from './PlusIcon16Regular';
import { PlusIcon16Solid } from './PlusIcon16Solid';
import { PlusIcon20Light } from './PlusIcon20Light';
import { PlusIcon20Regular } from './PlusIcon20Regular';
import { PlusIcon20Solid } from './PlusIcon20Solid';
import { PlusIcon24Regular } from './PlusIcon24Regular';
import { PlusIcon24Solid } from './PlusIcon24Solid';
import { PlusIcon32Regular } from './PlusIcon32Regular';
import { PlusIcon64Regular } from './PlusIcon64Regular';
var sizes = {
    16: {
        light: PlusIcon16Light,
        regular: PlusIcon16Regular,
        solid: PlusIcon16Solid,
    },
    20: {
        light: PlusIcon20Light,
        regular: PlusIcon20Regular,
        solid: PlusIcon20Solid,
    },
    24: {
        regular: PlusIcon24Regular,
        solid: PlusIcon24Solid,
    },
    32: {
        regular: PlusIcon32Regular,
    },
    64: {
        regular: PlusIcon64Regular,
    },
};
export var PlusIcon = forwardRef('PlusIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
